import { Typography } from '@fox/atoms';
import { FlexRowSpaced, PaddedY, SpaceBetweenRow } from '@fox/layout';
import { TableWrapper } from '../financial-details/receipts';
import { ActionCentreTable } from './action-centre-table';
import { FILTER_MIN_WIDTH, IActionCentreViewProps } from './contracts';
import { RenderFilterList } from './filters/filters';
import { ClearFiltersButton, ExportButtons, SourceFilter } from './shared-components';
export function TopFilterView({
	filter,
	columnsResult,
	sourceOptions,
	showFilters,
	enableClearFilters,
	setPage,
	setFilters,
	filters,
	sort,
	setSort,
	actionId,
	page,
	pageSize,
	disableExport,
	updateFilters,
	setSourceFilter,
	showSearch
}: IActionCentreViewProps) {
	return (
		<TableWrapper key={filter}>
			<Typography sx={{ paddingBottom: '1rem' }} variant="h5">
				{columnsResult.name}
			</Typography>
			{showFilters ? (
				<div style={{ minWidth: FILTER_MIN_WIDTH, paddingTop: '0' }}>
					<RenderFilterList
						filters={filters}
						updateFilters={(value, column) => updateFilters(value, column)}
						columns={columnsResult.columns}
						includeSearch={showSearch}
					/>
				</div>
			) : null}
			<div style={{ width: '100%', overflowX: 'auto' }}>
				<PaddedY>
					<SpaceBetweenRow>
						<FlexRowSpaced>
							{sourceOptions.length ? (
								<SourceFilter sourceOptions={sourceOptions} filter={filter} setSourceFilter={setSourceFilter} />
							) : null}
						</FlexRowSpaced>
						<FlexRowSpaced>
							{showFilters ? (
								<ClearFiltersButton
									enableClearFilters={enableClearFilters}
									setFilters={setFilters}
									setPage={setPage}
									filters={filters}
								/>
							) : null}
							{!disableExport ? (
								<ExportButtons
									actionId={actionId}
									columnsResult={columnsResult}
									filters={filters}
									sourceOptions={sourceOptions}
									filter={filter}
									sort={sort}
								/>
							) : null}
						</FlexRowSpaced>
					</SpaceBetweenRow>
				</PaddedY>
				<ActionCentreTable
					actionCentreColumns={columnsResult.columns}
					actionId={actionId}
					sourceFilter={filter}
					filters={filters}
					sort={sort}
					setSort={setSort}
					page={page}
					setPage={setPage}
					pageSize={pageSize}
					rowsExpandedOnSmallScreens={false}
				/>
			</div>
		</TableWrapper>
	);
}
